'use strict';

angular.module('app').constant('guideConstants', {
  EDIT_COUNTRY_KEY: 'edit_country',
  EDIT_AREA_KEY: 'edit_area',
});
